(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.customTechniquesInitialized) return;
    section.dataset.customTechniquesInitialized = 'true';

    const groups = Array.from(section.querySelectorAll('[data-techniques-group]'));
    const categories = Array.from(section.querySelectorAll('[data-techniques-category]'));
    const sidebarLinks = Array.from(section.querySelectorAll('[data-techniques-tab]'));
    if (groups.length === 0 || categories.length === 0) return;

    const groupByName = new Map();
    groups.forEach((g) => groupByName.set(g.getAttribute('data-techniques-group'), g));

    function openGroup(name) {
      groups.forEach((g) => {
        const isTarget = g.getAttribute('data-techniques-group') === name;
        g.classList.toggle('is-open', isTarget);
        const toggle = g.querySelector('[data-techniques-group-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
      });
    }

    function alignToCategory(name) {
      const category = categories.find((c) => c.getAttribute('data-techniques-category') === name);
      if (!category) return;
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      category.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    // Scope active-link toggling to the sidebar group the slide belongs to so
    // each slider tracks its own active link independently.
    function setActiveSidebarLink(slideId, groupKey) {
      const slidePrefix = groupKey || slideId.replace(/-slide-\d+$/, '');
      sidebarLinks.forEach((l) => {
        const linkId = l.getAttribute('data-techniques-tab');
        if (!linkId || !linkId.startsWith(slidePrefix + '-')) return;
        const active = linkId === slideId;
        l.classList.toggle('is-active', active);
        if (active) l.setAttribute('aria-current', 'true');
        else l.removeAttribute('aria-current');
      });
    }

    function closeGroup(group) {
      group.classList.remove('is-open');
      const toggle = group.querySelector('[data-techniques-group-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    groups.forEach((group) => {
      const toggle = group.querySelector('[data-techniques-group-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', () => {
        if (group.classList.contains('is-open')) {
          closeGroup(group);
          return;
        }
        const name = group.getAttribute('data-techniques-group');
        openGroup(name);
        requestAnimationFrame(() => alignToCategory(name));
      });
    });

    // Auto-open the group whose category enters viewport.
    if ('IntersectionObserver' in window) {
      const catObs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              openGroup(entry.target.getAttribute('data-techniques-category'));
            }
          });
        },
        { rootMargin: '-30% 0px -50% 0px', threshold: 0 }
      );
      categories.forEach((c) => catObs.observe(c));
    }

    // Slider -> sidebar: listen at section level so we catch events regardless of
    // when the slideshow-component upgrades.
    section.addEventListener('slideshow:select', (e) => {
      const id = e.detail && e.detail.id;
      const cat = e.target.closest('[data-techniques-category]');
      const groupKey = cat ? cat.getAttribute('data-techniques-category') : null;
      if (groupKey) openGroup(groupKey);
      if (id) setActiveSidebarLink(id, groupKey);
    });

    // Sidebar link click -> slider scroll to corresponding slide.
    sidebarLinks.forEach((link, idx) => {
      link.addEventListener('click', () => {
        const slideId = link.getAttribute('data-techniques-tab');
        if (!slideId) return;
        const slide = section.querySelector('slideshow-slide[slide-id="' + slideId + '"]');
        if (!slide) return;
        const ss = slide.closest('slideshow-component');
        if (!ss) return;
        if (typeof ss.select === 'function') {
          ss.select({ id: slideId });
        }
        const groupKey = slideId.replace(/-slide-\d+$/, '');
        setActiveSidebarLink(slideId, groupKey);
      });

      link.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        const dir = e.key === 'ArrowDown' ? 1 : -1;
        const next = sidebarLinks[(idx + dir + sidebarLinks.length) % sidebarLinks.length];
        if (next) next.focus();
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-custom-techniques]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
